var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPepperstone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 39,
    viewBox: "0 0 44 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.9165 7.482C30.8396 3.41446 16.1043 0.217954 8.30314 0.0107552C0.499982 -0.196444 -0.371058 2.58365 0.105701 8.91227C0.584472 15.2429 2.40903 25.1201 6.43633 31.4286C10.4616 37.7371 16.6877 40.4769 23.2879 38.2159C29.886 35.9528 36.8604 28.6887 40.6363 22.5874C44.4121 16.4901 44.9935 11.5495 37.9165 7.482ZM24.0624 24.8646H19.0996V33.1184H14.0464V14.7561H19.0996V19.8093H24.0624V19.7953C26.1444 19.7591 27.8221 18.0632 27.8221 15.9731C27.8221 13.883 26.1444 12.1852 24.0624 12.151V12.147H7.72782L9.5745 7.09375H24.0603C28.9768 7.09375 32.9639 11.0808 32.9639 15.9973C32.9659 20.9157 28.9788 24.8646 24.0624 24.8646Z",
    fill: "#0064FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0624 24.8646H19.0996V33.1184H14.0464V14.7561H19.0996V19.8093H24.0624V19.7953C26.1444 19.7591 27.8221 18.0632 27.8221 15.9731C27.8221 13.883 26.1444 12.1852 24.0624 12.151V12.147H7.72782L9.5745 7.09375H24.0603C28.9768 7.09375 32.9639 11.0808 32.9639 15.9973C32.9659 20.9157 28.9788 24.8646 24.0624 24.8646Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPepperstone);
export default __webpack_public_path__ + "static/media/pepperstone.4d3f0e134f3cefe1c6e6b68f32fb5174.svg";
export { ForwardRef as ReactComponent };